<template>
	
	<div class="twenty-padding scroll-y has-action-bar" v-loading="$store.getters.loading">
		
		<el-form v-if="settings.id" :model="settings" ref="settingsForm" label-position="top">
			
			<el-row :gutter=24>
				
				<el-col :span=12>
					
					<el-form-item label="Client Name">
						<el-input v-model="settings.name"></el-input>
					</el-form-item>
					
					<el-form-item label="Description">
						<el-input type="textarea" :rows="4" v-model="settings.description"></el-input>
					</el-form-item>
					
					<el-form-item label="Email">
						<el-input v-model="settings.email"></el-input>
					</el-form-item>
					
					<el-form-item label="Phone">
						<el-input v-model="settings.phone"></el-input>
					</el-form-item>
					
					<el-form-item label="Website">
						<el-input v-model="settings.website"></el-input>
					</el-form-item>
					
					<el-form-item label="Address">
						<el-input v-model="settings.address"></el-input>
					</el-form-item>
					
					<el-form-item label="Contacts">
						<UsersDropdown v-model="settings.contacts"/>
					</el-form-item>
					
				</el-col>
				
			</el-row>
			
		</el-form>
		
		<ActionBar :actions="actionButtons" @click="onClickActionButton"/>
		
	</div>
	
</template>

<script>
	
	import SettingsBase from "@/components/Base/Settings";
	
	export default {
		
		extends: SettingsBase,
		
		methods: {
			onClickActionButton(actionButton) {
				if (actionButton.name == "save") {
					this.$store.commit("setLoading", { type: "start" });
					this.axios.post(`clients/${this.settings.id}`, {
						client: this.settings,
					}).then((r) => {
						if (r.data.success) {
							this.$store.commit("setLoading", { type: "finish", message: "Your changes have been saved." });
							this.$store.dispatch("refreshSelectedClient", { data: r.data.clients[0] });
							this.dirty = false;
						}
					}).catch((e) => {
						this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while updating this client." });
					});
				}
			},
		},
		
		mounted() {
			this.$store.dispatch("refreshSelectedClient", {
				slug:  this.$route.params.clientSlug,
				callback: () => {
					this.settings = Object.assign({}, this.$store.getters.client);
					this.$watch("settings", (newValue, oldValue) => {
						this.dirty = true;
					}, { deep: true });
				}
			});
		},
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Clients/Settings.vue